import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {DataService} from "../../services/data.service";
import {UtilService} from "../../services/util.service";
import {Router} from "@angular/router";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-disable-contracts',
  templateUrl: './disable-contracts.component.html',
  styleUrls: ['./disable-contracts.component.scss']
})
export class DisableContractsComponent implements OnInit {

  loading = false;
  stateOptions: any[] = [];
  disableStates: string[] = [];
  contractForm: FormGroup;
  displayedColumns: any[] = [
    {field: 'jurisdictionState', label: 'State'},
    {field: 'username', label: 'Requested By'},
    {field: 'recordDate', label: 'Upload Date', type: 'date'}
  ];
  dataSource;
  @ViewChild('activeContractTable') activeContractTable;
  @ViewChild('attachments') attachments;

  constructor(public form: FormBuilder, private dataService: DataService, private utilService: UtilService, private route: Router) { }

  ngOnInit(): void {
    this.contractForm = this.form.group({
      // product: ['', Validators.required],
      state: ['', Validators.required],
      // market: ['', Validators.required],
      // file: ['', Validators.required]
    })
    this.getActiveContracts();
  }
  async getActiveContracts(){
    let self = this;
    this.loading = true;
    let disableStates: string[] = [];
    self.dataService.getApiData('quote-contract-gen/disable/getlist').subscribe((res: any) => {
      disableStates = res.map(item => item.jurisdictionState);
      this.disableStates = disableStates;
      this.dataSource = res;
      self.activeContractTable.initializeTable();
      this.loading = false;
    }, (err: HttpErrorResponse) => {
      this.loading = false;
      this.utilService.errorMessage('Fetch Failed')
    });

    this.stateOptions = await this.getDropdownOptions('listofstates') as any[];
  }
  getDropdownOptions(param){
    return new Promise((resolve, reject) => {
      this.dataService.getContractTemplateInfo(param).subscribe(res => {
        res = res.map(item => ({label: item, value: item}))
        resolve(res)
      }, err => resolve([]));
    })
  }

  disableState (){
    this.dataService.getApiData(`quote-contract-gen/disable/savedisable/${this.contractForm.value.state}`, 'POST', {}).subscribe(res => {
      this.utilService.successMessage('Disabled Successfully');
      this.contractForm.reset();
      this.getActiveContracts();

    }, err => {
      this.utilService.errorMessage('Error please try again');
      this.loading = false;
    })
  }
  disableTemplate(){
    this.loading = true;
    this.dataService.getApiData(`quote-contract-gen/disable/isitdisabled/${this.contractForm.value.state}`).subscribe(res => {
      if(!res) {
        this.disableState();
      }else {
        this.utilService.errorMessage('This features is temporarily suspended - please see your sales representative.....');
        this.loading = false;
      }


    }, err => {
      this.utilService.errorMessage('Error please try again');
      this.loading = false;
    })
  }

  deleteRow(row){
    this.loading = true;
    this.dataService.getApiData(`quote-contract-gen/disable/delete/${row.jurisdictionState}`, 'POST', {}).subscribe(res => {
      this.utilService.successMessage('Deleted Successfully');
      this.getActiveContracts();

    }, err => {
      this.utilService.errorMessage('Error please try again');
      this.loading = false;
    })
  }

}
